<template>
  <v-card
    :class="{
      cardCentered: cardCentered,
      cardTop: !cardCentered
    }"
    class="principalCard"
    :elevation="elevationCard"
    :shaped="shapedCard"
  >
    <img
      v-if="cardCentered"
      class="imageSearch"
      src="@/assets/tohru1.png"
      height="80"
      alt="Welcome"
    />
    <form
      @submit.prevent="runSearch"
      class="containerForm"
    >
      <header class="containerFlex">
        <v-text-field
          clearable
          dense
          hide-details="auto"
          name="searchInput"
          placeholder="Search pics"
          prepend-inner-icon="mdi-magnify"
          ref="searchInput"
          v-model="textSearch"
        />
        <a @click="openOptions">
          <v-icon class="iconOptions">
            {{ optionsIcon }}
          </v-icon>
        </a>

        <span
          v-if="getPermission"
          class="countChecked"
          alt="Selected Items"
        >
          {{ listPicturesCheckedlength }}
        </span>

        <v-icon
          v-if="getPermission"
          @click="handleChecked"
          class="iconConfig"
          :color="robotColor"
          >mdi-robot-excited
        </v-icon>

        <v-icon
          v-if="!cardCentered"
          :color="colorConfig"
          @click="loginModal = true"
          class="iconConfig"
        >
          mdi-cog
        </v-icon>
      </header>

      <section
        class="optionsSection"
        v-if="openedOptions"
      >
        <SearchOptions />
      </section>
    </form>

    <v-dialog
      v-model="loginModal"
      max-width="500px"
    >
      <v-card
        elevation
        :loading="loadingLogin"
        class="modalCard"
      >
        <v-card-title class="text-h5"> Admin access </v-card-title>
        <v-text-field
          placeholder="username"
          ref="usernameInput"
          v-model="admin.username"
        />
        <v-text-field
          v-model="admin.password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required]"
          :type="showPassword ? 'text' : 'password'"
          placeholder="password"
          counter
          @click:append="showPassword = !showPassword"
        />
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="loginModal = false"
          >
            Close
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="handleLogin"
          >
            Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import SearchOptions from './SearchOptions'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'SearchQuery',

  components: {
    SearchOptions
  },

  data: () => ({
    cardCentered: true,
    elevationCard: 10,
    shapedCard: true,
    textSearch: '',
    optionsIcon: 'mdi-chevron-down',
    openedOptions: false,
    colorConfig: '',
    loginModal: false,
    showPassword: false,
    loadingLogin: false,
    rules: {
      required: (value) => !!value || 'Required.'
    },
    admin: {
      username: '',
      password: ''
    }
  }),

  created() {
    this.focusSearch()
  },

  mounted() {
    this.$root.$on('updateSearchText', (text) => (this.textSearch = text))
    this.$root.$on('focusSearch', () => this.focusSearch())
  },

  computed: {
    ...mapGetters('admin', ['getPermission']),
    ...mapGetters('listPictures', ['listPicturesCheckedlength']),
    ...mapState('listPictures', ['listPictures']),

    robotColor: function () {
      if (this.listPicturesCheckedlength) {
        return 'blue'
      } else {
        return 'gray'
      }
    }
  },

  methods: {
    ...mapActions('admin', ['loginAdmin', 'setAdmin']),

    runSearch() {
      this.cardCentered = false
      this.elevationCard = 2
      this.shapedCard = false
      this.openedOptions = false
      this.optionsIcon = 'mdi-chevron-down'
      this.$vuetify.goTo(0, { duration: 500 })
      this.$emit('runSearch', this.textSearch)
    },

    openOptions() {
      this.optionsIcon === 'mdi-chevron-up'
        ? (this.optionsIcon = 'mdi-chevron-down')
        : (this.optionsIcon = 'mdi-chevron-up')

      this.openedOptions = !this.openedOptions
    },

    focusSearch() {
      this.$nextTick(() => this.$refs.searchInput.$refs.input.focus())
    },

    handleLogin() {
      this.loginAdmin(this.admin)
      this.colorConfig = 'green'
      this.loginModal = false
    },

    handleChecked() {
      this.$emit(
        'sendToKawnime',
        this.listPictures.filter((picture) => picture.checked === true)
      )
    }
  }
}
</script>

<style
  scoped
  lang="scss"
>
.principalCard {
  min-width: 400px;
  margin-right: 30px;
  animation: opacityGrowth;
  animation-duration: 4s;
  transition: all 0.5s linear;
}

.imageSearch {
  margin-right: 10px;
  filter: drop-shadow(-5px 0 3px gray);
}

.containerFlex {
  display: flex;
}

.containerForm {
  width: 100%;
}

.cardCentered {
  display: flex;
  padding: 15px 20px;
  align-items: center;
  max-width: 600px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cardTop {
  width: 100%;
  top: 0%;
  left: 50%;
  transform: translate(-50%, 0%);
  padding: 10px;
  position: fixed;
  z-index: 10;
}

.iconOptions {
  margin: 10px 10px 0px 10px;
}

.optionsSection {
  animation: fadeIn 1s;
}

.modalCard {
  padding: 30px;
}

.iconConfig {
  margin-left: 10px;
}

.countChecked {
  color: rgb(186, 184, 184);
  padding-top: 8px;
  align-items: center;
}
</style>
